import React from 'react'

const PageTitle = ({title}) => {
  return (
    <div className='w-full text-center font-display'>
        <h1 className='pt- pb-8 text-3xl font-display font-regular text-navy'>{title}</h1>
    </div>
  )
}

export default PageTitle